import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { SERVICES } from "../data/content";
import { FadeUp, SectionTag } from "../components/Motion";
import { RedRibbon } from "../components/Marquee";

const Services = () => (
  <>
    <PageHeader
      tag="Services — Seven weapons"
      title={
        <>
          Everything a brand needs <span className="text-nexa-red">to bite.</span>
        </>
      }
      sub="One roof, one drumbeat. Strategy to shoot floor to dashboard — no handoffs, no Chinese whispers, no diluted ideas."
    />

    <RedRibbon items={SERVICES.map((s) => s.title)} />

    <section className="mx-auto max-w-[1600px] px-5 py-24 md:px-10" data-testid="services-list">
      {SERVICES.map((s, i) => (
        <FadeUp key={s.id} delay={0.05}>
          <div
            id={s.id}
            className={`grid gap-8 py-14 md:grid-cols-12 ${i !== 0 ? "border-t border-white/10" : ""}`}
            data-testid={`service-block-${s.id}`}
          >
            <div className="md:col-span-2">
              <span className="font-display text-6xl text-nexa-red/90 md:text-7xl">{s.num}</span>
            </div>
            <div className="md:col-span-5">
              <h2 className="font-display text-4xl uppercase leading-none tracking-tight text-nexa-bone md:text-5xl">
                {s.seoTitle}
              </h2>
              <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-nexa-bone/40">{s.line}</p>
              <p className="mt-5 max-w-md text-base leading-relaxed text-nexa-bone/60">{s.para}</p>
              {s.links && (
                <p className="mt-5 max-w-md text-sm leading-relaxed text-nexa-bone/60" data-testid={`service-links-${s.id}`}>
                  →{" "}
                  {s.links.map((l, i) => (
                    <span key={l.to}>
                      {i > 0 && <span className="text-nexa-bone/30"> · </span>}
                      <Link to={l.to} className="link-line text-nexa-red">
                        {l.label}
                      </Link>
                    </span>
                  ))}
                </p>
              )}
              <Link
                to={`/contact?service=${s.id}`}
                data-testid={`service-cta-${s.id}`}
                className="link-line mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-nexa-red"
              >
                Brief us on this <ArrowRight size={14} />
              </Link>
            </div>
            <div className="md:col-span-5">
              <SectionTag className="text-nexa-bone/40">Deliverables</SectionTag>
              <ul className="mt-4 space-y-3">
                {s.points.map((p) => (
                  <li key={p} className="flex items-baseline gap-3 text-sm text-nexa-bone/70">
                    <span className="h-2 w-2 shrink-0 bg-nexa-red" />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </FadeUp>
      ))}
    </section>
  </>
);

export default Services;
